




































import Vue from 'vue'
import { ETableView } from '@/constants/dataTable'
import { columnConstants, Column, columns } from '@/helpers/columnConstants'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import CustomCheckbox from '@/components/Common/CustomCheckbox.vue'
import vClickOutside from 'v-click-outside'
import iconDownload from '@/assets/svg/rounded/download.svg?inline'
import iconSliders from '@/assets/svg/rounded/sliders1.svg?inline'

interface Props {
  title: string
  view: ETableView
  disableDownloadBtn: boolean
  total: number
  columns: Column[]
}

interface Data {
  showKanbanSetting: boolean
  selectedItem: Column
  selectItems: Column[]
  showSelect: boolean
}

interface Methods {
  getFile: () => void
  changeView: (view: ETableView) => void
  toggleKanbanSetting: () => void
  closeKanbansetting: () => void
  changeSelectedItem: (item: Column) => void
  setSelectItems: () => void
  toggleSelect: () => void
  closeSelect: () => void
}

interface Computed {
  model: ETableView
  isTableView: boolean
  isKanbanView: boolean
  showDownloadButton: boolean
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    iconDownload,
    iconSliders,
    PaidLabel,
    CustomCheckbox,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    title: {
      required: true,
    },
    view: {
      required: true,
    },
    disableDownloadBtn: {
      required: true,
    },
    total: {
      required: true,
    },
    columns: {
      required: true,
    },
  },
  data() {
    return {
      showSelect: false,
      showKanbanSetting: false,
      selectedItem: this.columns[0],
      selectItems: [],
    }
  },
  methods: {
    getFile() {
      this.$emit('getFile')
    },
    changeView(view) {
      if (this.model === view) {
        return
      }
      if (this.view === ETableView.table) {
        return (this.model = ETableView.kanban)
      }
      this.model = ETableView.table
    },
    toggleKanbanSetting() {
      this.showKanbanSetting = !this.showKanbanSetting
    },
    closeKanbansetting() {
      this.showKanbanSetting = false
    },
    changeSelectedItem(item) {
      this.selectedItem = item
      if (this.view === ETableView.kanban) {
        const query = Object.assign({}, this.$route.query)
        const newColumn = { kanbanColumn: item.key }
        this.$router.push({ query: { ...query, ...newColumn } })
      }
    },
    async setSelectItems() {
      await columnConstants().then(() => {
        this.selectedItem =
          columns.find(elem => elem.key === this.$route.query.kanbanColumn) ||
          columns[0]
        this.selectItems = columns
      })
    },
    toggleSelect() {
      if (this.view === ETableView.kanban) {
        this.showSelect = !this.showSelect
      }
    },
    closeSelect() {
      this.showSelect = false
    },
  },
  computed: {
    model: {
      get() {
        return this.view
      },
      set(value) {
        const query = Object.assign({}, this.$route.query)
        if (value === ETableView.table && this.$route.query.view) {
          delete query.view
          this.$router.push({ query: { ...query } })
        }
        if (value !== ETableView.table) {
          const newView = { view: value }
          this.$router.push({ query: { ...query, ...newView } })
        }
        this.$emit('input', value)
      },
    },
    isTableView() {
      return this.view === ETableView.table
    },
    isKanbanView() {
      return this.view === ETableView.kanban
    },
    showDownloadButton() {
      return this.$route.query.view !== 'kanban'
    },
  },
  mounted() {
    this.setSelectItems()
  },
})
